import React from 'react';
import { connect } from 'react-redux';
import { showModal, hideModal, updateModal } from '../../../actions/modal';
import DesktopHalfCard from './Desktop';
import MobileHalfCard from './Msite';
import { ModalDataType } from './types';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';

interface RatingHalfCardProps {
  displayHalfCard: boolean;
  modalData: ModalDataType;
  hideModal: (modalName: string) => void;
  updateModal: (modalName: string, {}) => void;
  displayLoader: boolean;
  fromFleek?: boolean;
}

const RatingHalfCard = (props: RatingHalfCardProps) => {
  const {
    displayHalfCard,
    modalData,
    hideModal,
    updateModal,
    displayLoader,
    fromFleek = false
  } = props;
  const {
    deviceType,
    rating,
    productDetails,
    sourcePage = '',
    onCloseCallback,
    pageName = '',
    pageType = ''
  } = modalData;
  const { description = '', skuId = '', brickCode = '', orderId = '' } = productDetails || {};
  const onClickHideModal = () => {
    if (onCloseCallback) {
      onCloseCallback();
    }
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'provide ratings halfcut pop up',
      event_label: 'cross',
      ...(orderId.length > 0 && { order_id: orderId }),
      product_id: skuId,
      product_name: description,
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      page_name: pageName,
      page_type: pageType,
      store_type: 'ajio'
    });
    hideModal('rating-halfcard');
  };
  if (deviceType === 'desktop') {
    return (
      <DesktopHalfCard
        productRating={rating}
        productDetails={productDetails}
        modalData={modalData}
        hideModal={onClickHideModal}
        updateModal={updateModal}
      />
    );
  }
  return (
    <MobileHalfCard
      displayModal={displayHalfCard}
      modalData={modalData}
      displayLoader={displayLoader}
      productRating={rating}
      hideModal={onClickHideModal}
      updateModal={updateModal}
      fromFleek={fromFleek}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const modals = state ? state.modals : {};
  const ratingModal = modals?.['rating-halfcard'] || {};
  const displayHalfCard = Object.entries(ratingModal).length === 0 ? false : true;
  const modalData = ratingModal.state || {};
  const { loaders = {} } = state;
  let displayLoader = false;
  if (loaders['ratings-reviews']) {
    displayLoader = true;
  }

  return {
    ...ownProps,
    displayLoader,
    modalData,
    displayHalfCard
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config)),
    hideModal: name => dispatch(hideModal(name)),
    updateModal: (name, config) => dispatch(updateModal(name, config))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RatingHalfCard);
